import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from '../components/Loader';

/**
 * SearchPage component - displays search results for karaoke videos
 */
const SearchPage = () => {
  const { keyword } = useParams();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`/api/videos/search`, { params: { query: keyword } });
        setVideos(data);
        setLoading(false);
      } catch (err) {
        setError(err.message || 'Failed to load search results');
        setLoading(false);
      }
    };

    fetchVideos();
  }, [keyword]);

  return (
    <Container className="py-4">
      <Link to="/" className="btn btn-light mb-4">
        Go Back
      </Link>
      
      <h1 className="mb-4">Search Results for "{keyword}"</h1>
      
      {loading ? (
        <div className="d-flex justify-content-center p-5">
          <Loader />
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : videos.length === 0 ? (
        <div className="alert alert-info">
          No videos found matching "{keyword}"
        </div>
      ) : (
        <Row>
          {videos.map((video, index) => (
            <Col key={video.id || index} sm={12} md={6} lg={4} xl={3} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Img 
                  variant="top" 
                  src={video.thumbnail ? `${video.thumbnail}` : "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450' viewBox='0 0 800 450'%3E%3Crect width='800' height='450' fill='%23333'/%3E%3Ctext x='400' y='225' font-family='Arial' font-size='30' fill='white' text-anchor='middle' dominant-baseline='middle'%3ENo Thumbnail%3C/text%3E%3C/svg%3E"} 
                  alt={video.title}
                  style={{ height: '180px', objectFit: 'cover' }}
                  onError={(e) => {
                    console.error('Image error:', e);
                    e.target.onerror = null;
                    e.target.src = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450' viewBox='0 0 800 450'%3E%3Crect width='800' height='450' fill='%23333'/%3E%3Ctext x='400' y='225' font-family='Arial' font-size='30' fill='white' text-anchor='middle' dominant-baseline='middle'%3ENo Thumbnail%3C/text%3E%3C/svg%3E";
                  }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="mb-auto">{video.title}</Card.Title>
                  <Link to={`/video/${video.id}`} className="btn btn-primary mt-2">
                    Watch
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

// Export the component as default
export default SearchPage;
